/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Image, Space, Dropdown, Menu } from "antd";
import { TableCell, TableRow } from "@mui/material";
import customStyles from "../../../../../assets/styles/customStyles";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import ElipsisIcon from "../../../../../assets/images/icon_actions/Elipsis.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import clsx from "clsx";
import { getColumnWidth, checkCRUDPermission, checkComponentPermission, idNamingConversion } from "../../../../../helpers/utilities";
import { Link, NavLink } from "react-router-dom";
import { customerGroupHead } from "../../../../../config/constant";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import SearchText from '../../../../Shared/components/SearchText';
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";

export const CustomerGroupTable = (props) => {
    const { details, onRequestSort, sortOrder, sortBy, onHandle,
        loadMore, handleOpen, loadMoreContent, loadMoreTask, search, roleManagement, onDelete } = props;


    const classes = customStyles();
    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={customerGroupHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={customerGroupHead.length}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i} >
                                                <TableCell style={{ width: getColumnWidth(customerGroupHead, 0) }}>
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Customer Group', 'view', 'Sales') ?
                                                            <NavLink
                                                                id={idNamingConversion('View_' + data.id, 'customerGroup', 'Link')}
                                                                to={"#"}
                                                                onClick={() => onHandle(data, true, true)}
                                                                className={clsx(classes.color, classes.wordBreak, classes.positionRelative, classes.disBlock, classes.bold)}>
                                                                {data.name}
                                                            </NavLink> : data.name
                                                    }
                                                </TableCell>
                                                <TableCell style={{ width: getColumnWidth(customerGroupHead, 1) }}><span style={{ width: "100%", whiteSpace: "break-spaces", lineHeight: 1.5 }} className={classes.descEllipsis}>{data.description ? data.description : '---'}</span></TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Customer Group', 'view', 'Sales') &&
                                                            <NavLink id={idNamingConversion('View_' + data.id, 'customerGroup', 'Icon')} to={"#"} onClick={() => onHandle(data, true, true)}>
                                                                <Image src={ViewIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Customer Group', 'edit', 'Sales') &&
                                                            <NavLink id={idNamingConversion('Edit_' + data.id, 'customerGroup', 'Icon')} to={"#"} onClick={() => onHandle(data, false, true)}>
                                                                <Image src={EditIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Customer Group', 'deletable', 'Sales') &&
                                                            <NavLink id={idNamingConversion('Delete_' + data.id, 'customerGroup', 'Icon')} to={"#"} onClick={() => onDelete(data)}>
                                                                <Image src={DeleteIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                        <Dropdown
                                                            trigger={['click']}
                                                            placement={'bottomRight'}
                                                            overlay={
                                                                <Menu className={clsx(classes.groupMenu)}>
                                                                    <Menu.Item className={clsx(classes.accordionSubmenuArrow)}></Menu.Item>
                                                                    {
                                                                        roleManagement !== '' && checkComponentPermission('Customer Group', 'Ellipsis Action', 'View Customer') &&
                                                                        <Menu.Item><Link id={idNamingConversion('View Customer_' + data.id, 'customerGroup', 'Link')} to={`/sales/sales-management/${data.id}/all-customers`}>View Customer</Link></Menu.Item>
                                                                    }
                                                                </Menu>
                                                            }>
                                                            <Image id={idNamingConversion('Elipsis_' + data.id, 'customerGroup', 'Icon')} src={ElipsisIcon} preview={false} />
                                                        </Dropdown>
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={customerGroupHead.length}>
                                                    {
                                                        search !== '' ? <SearchText /> : <>
                                                            <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start by grouping your Customers'}</p>
                                                            <div className={classes.margin20t}>
                                                                <NavLink
                                                                    style={{ display: "inline-block" }}
                                                                    to={`#`}
                                                                    onClick={() => handleOpen()}
                                                                    className={clsx(classes.modalBtn)}>Create Customer Group
                                                                </NavLink>
                                                            </div>
                                                        </>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
        </>
    )
}
